export default "__VITE_ASSET__B8L_n3rg__"